/**
 * Ghost Supply ROI Dashboard — CFO View
 */

import { OpsLayout } from '@/components/ops/OpsLayout';
import { GhostSupplyDashboard } from '@/components/supply/GhostSupplyDashboard';

export default function GhostSupplyROI() {
  return (
    <OpsLayout>
      <div className="max-w-7xl mx-auto space-y-1">
        <div className="mb-6">
          <h1 className="text-2xl font-bold tracking-tight">Ghost Supply ROI</h1>
          <p className="text-sm text-muted-foreground mt-1">
            CFO View — Track supply waste eliminated, nursing hours recovered, and priority procedures for card cleansing.
          </p>
        </div>
        <GhostSupplyDashboard />
      </div>
    </OpsLayout>
  );
}
